const pathsWithoutLangPref = [
    '/prive',
    '/prive/coupon-list',
    '/prive/reward-list',
];

export default pathsWithoutLangPref;
